var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:(_vm.prefixCls + "-wrapper")},[_c('span',{class:_vm.checkboxClass},[_c('span',{class:(_vm.prefixCls + "__inner"),on:{"click":_vm.toggle}})])])}
var staticRenderFns = []

export { render, staticRenderFns }